<template>
  <div class="order_list">
    <!-- 头部搜索 -->
    <title-bar-search :showBack="true" class="title_search" @back="back">
      <div class="input_s clearfix" @click="goSearch">
        <img
          src="@/assets/common/icon_search_search@2x.png"
          alt="select"
          class="search_img left"
        />
        <div class="search_name left">订单号/商品名称/收货人</div>
      </div>
    </title-bar-search>
    <div class="line_height"></div>
    <!-- switchBar -->
    <switch-bar-list :switchIndex="switchIndex" @clickSwitch="clickSwitch" />
    <!-- 订单 -->
    <van-pull-refresh
      v-if="
        findClientRetailOrderByParam.rows &&
          findClientRetailOrderByParam.rows.length !== 0
      "
      v-model="loading"
      @refresh="onRefresh"
    >
      <van-list
        v-model="loading"
        :finished="!findClientRetailOrderByParam.hasNextPage"
        finished-text="我已经到底啦～"
        @load="onLoad"
      >
        <div class="order_list_items">
          <div
            v-for="(item, index) in findClientRetailOrderByParam.rows"
            :key="index"
            class="items"
          >
            <!-- 订单头部信息 -->
            <order-header :storeDet="item" @clickBtn="clickBtn" />
            <div v-for="(i, index1) in item.retailSubOrderList" :key="index1">
              <div
                v-if="
                  item.retailSubOrderList &&
                    item.retailSubOrderList.length > 1 &&
                    item.retailSubOrderList !== null
                "
                :class="{ bao_mr: index1 !== 0 }"
                class="font12 font_weight500 colo087 text_left bao_name"
              >
                包裹{{ index1 + 1 }}
              </div>
              <!-- 商品信息 -->
              <div>
                <div v-for="(i1, index2) in i.orderDetailList" :key="index2">
                  <order-product-list
                    v-if="!i1.isGift"
                    :listIndex="index2"
                    :pageShow="false"
                    :item="i1"
                    :i="item"
                    @goOrderDetail="goOrderDetail"
                  />
                  <!-- 赠品 -->
                  <div v-if="i1.isGift" class="free_product_list">
                    <free-product
                      :showBor="false"
                      :freeProduct="i1"
                      :orderSn="item.orderSn"
                      @goOrderDetail="goOrderDetail"
                    />
                  </div>
                </div>
                <!-- 多包裹底部按钮 -->
                <bottom-btn
                  v-if="
                    item.retailSubOrderList &&
                      item.retailSubOrderList.length > 1 &&
                      item.retailSubOrderList !== null &&
                      item.status !== 10 &&
                      item.status !== -10 &&
                      item.status !== -11
                  "
                  :btnList="
                    orderBtn(
                      item.retailSubOrderList.length,
                      i.orderType,
                      i.status
                    )
                  "
                  :i="i"
                  :item="item"
                  :packageIndex="index1"
                  @clickBtn="clickBtn"
                />
              </div>
            </div>

            <!-- 订单（单包裹）底部按钮 -->
            <bottom-btn
              v-if="
                item.retailSubOrderList &&
                  item.retailSubOrderList !== null &&
                  (item.retailSubOrderList.length === 1 ||
                    (item.retailSubOrderList.length > 1 &&
                      (item.status === 10 ||
                        item.status === -10 ||
                        item.status === -11)))
              "
              :btnList="
                orderBtn(
                  item.retailSubOrderList.length,
                  item.orderType,
                  item.status
                )
              "
              :i="item.retailSubOrderList[0]"
              :item="item"
              @clickBtn="clickBtn"
            />
            <div
              class="font12 font_weight500 colo0 line_height_17 order_total_det text_right"
            >
              共{{ item.totalNum }}件商品 总计：{{
                item.total | currency(false)
              }}
            </div>
          </div>
        </div>
      </van-list>
    </van-pull-refresh>
    <cancel-action-sheet
      v-if="showCancel"
      @closeSheet="closeSheet"
      @confirmReasion="confirmReasion"
    />
    <!-- 无结果 -->
    <div
      v-if="
        findClientRetailOrderByParam.rows &&
          findClientRetailOrderByParam.rows.length === 0
      "
      class="none_list"
    >
      <img src="@/assets/order/search_none_product@2x.png" alt="" />
      <div class="font14 font_weight400 colo038 line_height_20">
        未找到相关订单
      </div>
    </div>
  </div>
</template>
<script>
import TitleBarSearch from "@/components/TitleBarSearch";
import SwitchBarList from "./components/SwitchBarList";
import OrderHeader from "./components/OrderHeader";
import OrderProductList from "./components/OrderProductList";
import BottomBtn from "./components/BottomBtn";
import FreeProduct from "../detail/components/FreeProduct";
import CancelActionSheet from "../detail/components/CancelActionSheet";
export default {
  name: "OrderList",
  components: {
    TitleBarSearch,
    SwitchBarList,
    OrderHeader,
    OrderProductList,
    BottomBtn,
    FreeProduct,
    CancelActionSheet
  },
  data() {
    return {
      switchIndex: 0,
      loading: false,
      showCancel: false,
      orderSn: ""
    };
  },
  computed: {
    findClientRetailOrderByParam() {
      return this.$store.getters.findClientRetailOrderByParam;
    }
  },
  created() {
    this.switchIndex =
      parseInt(localStorage.getItem("mall-order-list-index")) || 0;
    this.getData(this.switchIndex);
  },
  methods: {
    // findClientRetailOrderByParam
    getData(status = 0, pageNo = 1, pageSize = 20) {
      const params = {
        pageNo,
        pageSize,
        status
      };
      // console.log(params, "params");
      this.$store
        .dispatch("order/findClientRetailOrderByParam", { params })
        .then(() => {
          this.loading = false;
        })
        .catch(() => {});
    },
    onRefresh() {
      this.getData(this.switchIndex);
    },
    onLoad() {
      // console.log("上拉进行中");
      this.loading = false;
      if (
        this.findClientRetailOrderByParam.hasNextPage &&
        this.findClientRetailOrderByParam.pageNo <
          this.findClientRetailOrderByParam.pageCount
      ) {
        this.loading = true;
        const pageIndex = this.findClientRetailOrderByParam.pageNo + 1;
        this.getData(this.switchIndex, pageIndex);
        // console.log("上拉完毕");
      }
    },
    back() {
      this.$router.push("/mine");
    },
    // 订单搜索跳转
    goSearch() {
      this.$router.push("/order/searchorder");
    },
    // 点击切换bar
    clickSwitch(index) {
      this.switchIndex = index;
      localStorage.setItem("mall-order-list-index", index);
      scrollTo(0, 0);
      this.getData(index);
    },
    closeSheet() {
      this.showCancel = false;
    },
    confirmReasion(refundReason) {
      this.cancelData(refundReason);
    },
    // 跳转详情
    goOrderDetail(orderSn) {
      this.$router.push({
        path: "/order/detail",
        query: {
          orderSn
        }
      });
    },
    orderBtn(orderListLength, orderType, status) {
      // orderListLength 通过包裹的长度 1是单包裹，>1是多包裹
      // orderType 0普通商品 1周期购 2虚拟卡
      // afterType 0不可取消 1可取消 2可售后
      // status 订单状态(单包裹订单维度状态，多包裹是包裹维度的状态)
      switch (status) {
        // 待付款
        case 10:
          return [
            {
              name: "取消订单",
              isLightHeight: false
            },
            {
              name: "去付款",
              isLightHeight: true
            }
          ];
        // 待发货
        case 11:
          // 单包裹
          if (orderListLength === 1) {
            switch (orderType) {
              // 普通商品
              case 0:
                return [
                  {
                    name: "查看物流",
                    isLightHeight: false
                  },
                  {
                    name: "提醒发货",
                    isLightHeight: true
                  }
                ];
              // 周期购
              case 1:
                return [
                  {
                    name: "配送计划",
                    isLightHeight: false
                  },
                  {
                    name: "提醒发货",
                    isLightHeight: true
                  }
                ];
            }
            // 多包裹
          } else {
            switch (orderType) {
              // 普通商品
              case 0:
                return [
                  {
                    name: "查看物流",
                    isLightHeight: false
                  },
                  {
                    name: "提醒发货",
                    isLightHeight: true
                  }
                ];
              // 周期购
              case 1:
                return [
                  {
                    name: "配送计划",
                    isLightHeight: false
                  },
                  {
                    name: "提醒发货",
                    isLightHeight: true
                  }
                ];
            }
          }
          break;
        // 待收货
        case 12:
          // 单包裹
          if (orderListLength === 1) {
            switch (orderType) {
              // 普通商品
              case 0:
                return [
                  {
                    name: "查看物流",
                    isLightHeight: false
                  },
                  {
                    name: "确认收货",
                    isLightHeight: true
                  }
                ];
              // 周期购
              case 1:
                return [
                  {
                    name: "配送计划",
                    isLightHeight: false
                  }
                ];
            }
            // 多包裹
          } else {
            switch (orderType) {
              // 普通商品
              case 0:
                return [
                  {
                    name: "查看物流",
                    isLightHeight: false
                  },
                  {
                    name: "确认收货",
                    isLightHeight: true
                  }
                ];
              // 周期购
              case 1:
                return [
                  {
                    name: "配送计划",
                    isLightHeight: false
                  }
                ];
            }
          }
          break;
        // 已完成
        case 13:
        case 14:
          if (orderListLength === 1) {
            switch (orderType) {
              // 普通商品
              case 0:
                return [
                  {
                    name: "去评价",
                    isLightHeight: false
                  },
                  {
                    name: "查看物流",
                    isLightHeight: false
                  },
                  {
                    name: "再次购买",
                    isLightHeight: true
                  }
                ];
              // 周期购
              case 1:
                return [
                  {
                    name: "配送计划",
                    isLightHeight: false
                  },
                  {
                    name: "再次购买",
                    isLightHeight: true
                  }
                ];
              // 虚拟卡
              case 2:
                // 未兑换的 购买的 卡。展示前往使用？
                return [
                  {
                    name: "前往使用",
                    isLightHeight: true
                  }
                ];
            }
            // 多包裹
          } else {
            switch (orderType) {
              // 普通商品
              case 0:
                return [
                  {
                    name: "查看物流",
                    isLightHeight: false
                  },
                  {
                    name: "再次购买",
                    isLightHeight: true
                  }
                ];
              // 周期购
              case 1:
                return [
                  {
                    name: "配送计划",
                    isLightHeight: false
                  },
                  {
                    name: "再次购买",
                    isLightHeight: true
                  }
                ];
              // 虚拟卡
              case 2:
                return [
                  {
                    name: "前往使用",
                    isLightHeight: true
                  }
                ];
            }
          }
          break;
        // 已关闭
        case -10:
        case -11:
          return [
            {
              name: "再次购买",
              isLightHeight: false
            }
          ];
      }
    },
    // 取消接口
    cancelData(refundReason) {
      this.$store
        .dispatch("order/cancelOrder", {
          params: {
            orderSn: this.orderSn,
            refundReason
          }
        })
        .then(() => {
          this.getData(this.switchIndex);
          this.showCancel = false;
          this.$toast("订单取消成功");
        })
        .catch(() => {});
    },
    // 删除接口
    deleteData(orderSn) {
      this.$store
        .dispatch("order/deleteOrder", {
          params: {
            orderSn
          }
        })
        .then(() => {
          this.getData(this.switchIndex);
          this.showCancel = false;
          this.$toast("订单删除成功");
        })
        .catch(() => {});
    },
    // 再次购买接口
    againBuy(orderSn) {
      this.$store
        .dispatch("order/againBuy", {
          params: {
            orderSn
          }
        })
        .then(() => {
          this.$router.push("/cart");
        })
        .catch(() => {});
    },
    // 确认收货
    confirmOrder(subOrderSn) {
      this.$store
        .dispatch("order/confirmOrder", {
          params: {
            subOrderSn
          }
        })
        .then(() => {
          this.getData(this.switchIndex);
        })
        .catch(() => {});
    },
    getSpuId(item) {
      const { retailSubOrderList } = item;
      let spuId = "";
      retailSubOrderList.forEach(item => {
        item.orderDetailList.forEach(i => {
          if (!i.isGift) {
            spuId = i.spuId;
            return;
          }
        });
      });
      return spuId;
    },
    // 点击按钮
    clickBtn(name, orderSn, subOrderSn, packageIndex, orderType, spuId, item) {
      switch (name) {
        case "取消订单":
          this.showCancel = true;
          this.orderSn = orderSn;
          break;
        case "去付款":
          // /order/orderpay?orderSn=FY20112062347625
          this.$router.push({
            path: "/order/orderpay",
            query: {
              orderSn
            }
          });
          break;
        case "查看物流":
          this.$router.push({
            path: "/order/detail/logistics",
            query: {
              orderSn,
              subOrderSn,
              packageIndex
            }
          });
          break;
        case "提醒发货":
          this.$toast("已提醒发货");
          break;
        case "申请退款":
          this.$router.push({
            path: "/order/refund/orderdetailrefundreasion",
            query: {
              orderSn,
              name: this.getUserOrder.address.name,
              phone: this.getUserOrder.address.phone
            }
          });
          break;
        case "确认收货":
          this.$dialog
            .confirm({
              message: "您确定要确认收货吗？",
              confirmButtonText: "确定",
              confirmButtonColor: "#DD9132"
            })
            .then(() => {
              // 确认收货
              this.confirmOrder(subOrderSn);
            })
            .catch(() => {});
          break;
        case "再次购买":
          if (orderType === 0) {
            this.againBuy(orderSn);
          } else {
            // 跳转详情
            this.$router.push({
              path: "/product/detail",
              query: {
                id: spuId || this.getSpuId(item)
              }
            });
          }
          break;
        case "申请售后":
          this.$router.push({
            path: "/order/refund/applypackage",
            query: {
              orderType: this.getUserOrder.orderType,
              orderSn
            }
          });
          break;
        case "删除订单":
          this.$dialog
            .confirm({
              message: "您确定要删除该订单吗？",
              confirmButtonText: "确定",
              confirmButtonColor: "#DD9132"
            })
            .then(() => {
              this.deleteData(orderSn);
            })
            .catch(() => {});
          break;
        case "配送计划":
          this.$router.push({
            path: "/order/milkplan",
            query: {
              orderSn,
              subOrderSn
            }
          });
          break;
        case "前往使用":
          this.$router.push({
            path: "/mine/cardpackagelist"
          });
          break;
        case "去评价":
          this.$router.push({
            path: "/order/review",
            query: {
              orderSn,
              subOrderSn
            }
          });
          break;
      }
    },
    // 取消订单
    cancelOrder() {
      this.showCancel = true;
    }
  }
};
</script>
<style lang="less" scoped>
.order_list {
  // background: #fff;
  .title_search {
    background: #fff;
  }
  .input_s {
    text-align: left;
    background: #f6f7f8;
    border-radius: 17px;
    font-size: 12px;
    display: flex;
    flex-direction: row;
    height: 34px;
    .search_name {
      margin-left: 12px;
      margin-top: auto;
      margin-bottom: auto;
      font-weight: 400;
      color: #222;
      padding: 8px 0;
      opacity: 0.38;
    }
    .search_img {
      // margin-top: 2px;
      margin-left: 8px;
      width: 24px;
      margin-top: auto;
      margin-bottom: auto;
    }
  }
  .line_height {
    height: 48px;
  }
  .order_list_items {
    margin-top: 57px;
    .items {
      background: #fff;
      margin-top: 12px;
      .bao_name {
        padding: 4px 12px;
      }
      .bao_mr {
        // border-top: 4px solid #f6f7f8;
      }
    }
  }
  .free_product_list {
    background: #fff;
    margin: 0 12px;
  }
  .none_list {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    img {
      width: 60px;
    }
  }
}
.order_total_det {
  padding: 16px 22px 16px 0;
}
</style>
